module.exports = __webpack_public_path__ + "static/media/date-picker-arrow-down.131ef661.svg";